import { useTaskTemplateCache } from "src/data/taskManagement/taskTemplateQueriesCache"
import { useMinutPost } from "src/hooks/minutQuery"

export function usePostTaskTemplate() {
  const taskCache = useTaskTemplateCache()

  return useMinutPost<
    "/organizations/{organization_id}/tasks/templates",
    "403"
  >({
    pathFn: (path) => `/organizations/${path.organization_id}/tasks/templates`,
    options: {
      onSuccess: () => {
        return taskCache.invalidateTaskTemplateList()
      },
    },
  })
}
